import React from "react";
import SimplePage from "../../shared/SimplePage";

export default function Privacy() {
  return <SimplePage title="Privacy Policy" />;
}
